import * as Blockly from 'blockly-tradais';
import { AtlasFieldBridge } from './atlas-field-bridge';
import { javascriptGenerator } from 'blockly-tradais/javascript';

export const SpecialFunctionsFns = {
  customBlockForShowLoadingScreen() {
    Blockly.Blocks['show_loading_screen'] = {
      init: function () {

        this.appendValueInput('showLoading').setCheck('Boolean').appendField('show loading screen');
        // this.setOutput(true);
         this.setInputsInline(false);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour('#745ba5');
        this.setTooltip('show loading screen');
        this.setHelpUrl('');
      },
    };

    (javascriptGenerator as any).forBlock['show_loading_screen'] = function (
      block: any
    ) {
      var loading =
        (javascriptGenerator as any).valueToCode(
          block,
          'showLoading',
          (javascriptGenerator as any).ORDER_ASSIGNMENT
        ) || 'NAN';
      // if (loading !== 'NAN')
        // return `this.loading.isLoadingManual = ${loading};\n`;
      return '';
    };
  } ,
    customBlockForGetCurrentUser() {
    Blockly.Blocks['get_current_user'] = {
      init: function () {
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.appendDummyInput('VALUE')
          .appendField('get current user')
        this.appendValueInput('user')
          .setCheck('ENTITY')
          .appendField('user');
      },
    };

    (javascriptGenerator as any).forBlock['get_current_user'] =
      function (block: any) {
        const variableName = (javascriptGenerator as any).valueToCode(
          block,
          'user',
          (javascriptGenerator as any).ORDER_ASSIGNMENT
        );
        if (variableName === 'NAN') {
          return ''
        }
        var code = '';
        code += `${variableName}.data`;
        code += " = await this.userService.getCurrentUser(); \n";
        return code;
        // return variableName + ' =' + value + ';\n';
      };
  } ,
    // VALUE block — the signed-in user's role id ('admin' / a business role / 'inactive').
    customBlockForGetCurrentUserRole() {
      Blockly.Blocks['get_current_user_role'] = {
        init: function () {
          this.appendDummyInput().appendField('current user role');
          this.setOutput(true, 'String');
          this.setColour('#745ba5');
          this.setTooltip("The signed-in user's role id ('admin', a business role, or 'inactive'). Plug into a string variable or a comparison.");
          this.setHelpUrl('');
        },
      };
      (javascriptGenerator as any).forBlock['get_current_user_role'] = function () {
        return ['await this.userService.getCurrentUserRole()', (javascriptGenerator as any).ORDER_ATOMIC];
      };
  } ,
    customBlockForGetUsers() {
      Blockly.Blocks['get_users_list'] = {
        init: function () {
          this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.appendDummyInput('VALUE')
            .appendField('get user list')
          this.appendValueInput('users')
            .setCheck('Array')
            .appendField('users');
        },
      };
  
      (javascriptGenerator as any).forBlock['get_users_list'] =
        function (block: any) {
          const variableName = (javascriptGenerator as any).valueToCode(
            block,
            'users',
            (javascriptGenerator as any).ORDER_ASSIGNMENT
          );
          if (variableName === 'NAN') {
            return ''
          }
          var code = '';
          code += variableName;
          code += ' = await this.userService.query();\n';
          code += '\nthis.reinitializeComponantsFlag = true;';
          return code;
          // return variableName + ' =' + value + ';\n';
        };
    } ,
        customBlockForGetRoles() {
        Blockly.Blocks['get_roles_list'] = {
          init: function () {
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.appendDummyInput('VALUE')
              .appendField('get roles list')
            this.appendValueInput('roles')
              .setCheck('Array')
              .appendField('roles');
          },
        };
    
        (javascriptGenerator as any).forBlock['get_roles_list'] =
          function (block: any) {
            const variableName = (javascriptGenerator as any).valueToCode(
              block,
              'roles',
              (javascriptGenerator as any).ORDER_ASSIGNMENT
            );
            if (variableName === 'NAN') {
              return ''
            }
            var code = '';
            code += variableName;
            code += ' = await this.roleService.query(1000, false);\n';
            return code;
          };
      } ,
        customBlockForCreateUser() {
          Blockly.Blocks['create_user'] = {
            init: function () {
              this.appendDummyInput()
                .appendField('create user');
                // .appendField(
                //   new NonEditableFieldVariable(
                //     'NAN',
                //     undefined,
                //     ['ENTITYNAME'],
                //     'ENTITYNAME'
                //   ),
                //   'VAR'
                // );
      
              // this.setOutput(true, 'Boolean');
              this.setPreviousStatement(true, null);
              this.setNextStatement(true, null);
              this.setColour('#ffd700');
              this.setTooltip('Create a Entity in db');
              this.setHelpUrl('');
            },
          };
      
      
          class NonEditableFieldVariable extends Blockly.FieldVariable {
            constructor(
              variableName: any,
              validator: any,
              variableTypes: any,
              defaultType: any
            ) {
              super(variableName, validator, variableTypes, defaultType);
            }
      
            // Override the showEditor_ method to disable editing
            override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
          }
      
          (javascriptGenerator as any).forBlock['create_user'] =
            function (block: any) {
              // var variableName = (javascriptGenerator as any).nameDB_.getName(
              //   block.getFieldValue('VAR'),
              //   'VARIABLE'
              // );
              // if (variableName === 'NAN') {
              //   return ''
              // }
      
              var variableName = 'user_global';
              // var code = `${variableName}$.id = ${variableName}$.userName;\n`;
              var code = `await this.userService.create(${variableName}$);\n`;
              return code;
              // return variableName + ' =' + value + ';\n';
            };
        } ,
           customBlockForEditUser() {
        
              Blockly.Blocks['edit_user'] = {
                init: function () {
                  this.appendDummyInput()
                    .appendField('edit user');
                    // .appendField(
                    //   new NonEditableFieldVariable(
                    //     'NAN',
                    //     undefined,
                    //     ['ENTITYNAME'],
                    //     'ENTITYNAME'
                    //   ),
                    //   'VAR'
                    // );
        
                       this.appendValueInput('VARIABLE')
                  .setCheck('ENTITY');
        
                  this.setPreviousStatement(true, null);
                  this.setNextStatement(true, null);
                  this.setColour('#ffd700');
                  this.setTooltip('Edit an existing user in the db');
                  this.setHelpUrl('');
                },
              };
                  class NonEditableFieldVariable extends Blockly.FieldVariable {
              constructor(
                variableName: any,
                validator: any,
                variableTypes: any,
                defaultType: any
              ) {
                super(variableName, validator, variableTypes, defaultType);
              }
        
              // Override the showEditor_ method to disable editing
              override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
            }
              // Uses ReadonlyFieldVariable so no inline editing is allowed
        
              (javascriptGenerator as any).forBlock['edit_user'] = function (block: any) {
               
                const variableName = (javascriptGenerator as any).valueToCode(
                  block,
                  'VARIABLE',
                  (javascriptGenerator as any).ORDER_ASSIGNMENT
                );
                // var variableName = (javascriptGenerator as any).nameDB_.getName(
                //   block.getFieldValue('VAR'),
                //   'VARIABLE'
                // );
                // if (variableName === 'NAN') {
                //   return '';
                // }
                // var code = `${variableName}$.id = ${variableName}$.userName;\n`;
                // mirror create user but call edit method for clearer intent
                var code = `await this.userService.edit(${variableName}.data);\n`;
                return code;
              };
            } ,
              customBlockForGetEmail() {
                Blockly.Blocks['get_email'] = {
                  init: function () {
            
                    this.appendDummyInput().appendField('get email');
                    this.setOutput(true, 'String');
                    this.setInputsInline(true);
                    this.setColour('#FF0000');
                    this.setTooltip('Email');
                    this.setHelpUrl('');
                  },
                };
            
                (javascriptGenerator as any).forBlock['get_email'] = function (
                  block: any
                ) {
                 var code = 'this.authService.user.email';
                  return [code, (javascriptGenerator as any).ORDER_ATOMIC];;
                };
              } ,
               customBlockForNavigation() {
                  // Define 'set_variable' block
                  Blockly.Blocks['set_navigation'] = {
                    init: function () {
                      this.appendDummyInput()
                        .appendField('navigateTo')
                        .appendField(
                          new Blockly.FieldVariable(
                            'NAN',
                            undefined,
                            ['NAVIGATE'],
                            'NAVIGATE'
                          ),
                          'VAR'
                        );
              
                      this.setPreviousStatement(true, null);
                      this.setColour('#FF0000');
                      this.setTooltip('select page to navigate');
                      this.setHelpUrl('');
                    },
                  };
                  (javascriptGenerator as any).forBlock['set_navigation'] = function (
                    block: any
                  ) {
                    var variableName = (javascriptGenerator as any).nameDB_.getName(
                      block.getFieldValue('VAR'),
                      'VARIABLE'
                    );
                    if (variableName == 'NAN') {
                      return '';
                    }
                    return "await this.reinitialize('" + variableName + "');\n";
                  };
                } ,
                customBlockForOpenExternalString() {
                  Blockly.Blocks['open_external_string'] = {
                    init: function () {
                      this.appendValueInput('URL')
                        .setCheck('String')
                        .appendField('open link'); // was 'open external string' (2026-10-06); the type is unchanged

                      this.setPreviousStatement(true, null);
                      this.setNextStatement(true, null);
                      this.setColour('#FF0000');
                      this.setTooltip('Opens a link: a web page (new tab), or tel: / mailto: / sms: to start a call, email or text. A bare email or web address is completed; a phone number needs tel: in front.');
                      this.setHelpUrl('');
                    },
                  };

                  (javascriptGenerator as any).forBlock['open_external_string'] = function (
                    block: any
                  ) {
                    const urlValue =
                      (javascriptGenerator as any).valueToCode(
                        block,
                        'URL',
                        (javascriptGenerator as any).ORDER_ASSIGNMENT
                      ) || "''";

                    return `await this.openExternalString(${urlValue});\n`;
                  };
                } ,
                  customBlockForLogout() {
                        Blockly.Blocks['logout_user'] = {
                        init: function () {
                            this.appendDummyInput().appendField('logout user');
                            this.setOutput(true, 'Boolean');
                            this.setInputsInline(true);
                            this.setColour('#FF0000');
                            this.setTooltip('Log out the current user');
                            this.setHelpUrl('');
                        },
                        };

                        (javascriptGenerator as any).forBlock['logout_user'] = function () {
                        var code = 'await this.authService.logout()';
                        return [code, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                    } ,
                      customBlockForShowToast() {
                        Blockly.Blocks['show_toast'] = {
                          init: function () {
                            this.appendDummyInput()
                              .appendField("Show toast")
                              .appendField(new Blockly.FieldDropdown([
                                ["Info", "info"], 
                                ["Error", "error"], 
                                ["Warning", "warning"], 
                                ["Success", "success"]
                              ]), "TOAST_TYPE");
                              
                            this.appendValueInput("MESSAGE")
                              .setCheck("String")
                              .appendField("message");
                              
                            this.appendValueInput("DURATION")
                              .setCheck("Number")
                              .appendField("duration (ms)");
                              
                            this.setInputsInline(false);
                            this.setPreviousStatement(true, null);
                            this.setNextStatement(true, null);
                            this.setColour('#3498db');
                            this.setTooltip("Show a toast notification message");
                            this.setHelpUrl("");
                          }
                        };
                    
                        (javascriptGenerator as any).forBlock['show_toast'] = function(block: any) {
                          const toastType = block.getFieldValue('TOAST_TYPE');

                          const message = (javascriptGenerator as any).valueToCode(
                            block,
                            'MESSAGE',
                            (javascriptGenerator as any).ORDER_ATOMIC
                          ) || "''";

                          let duration = (javascriptGenerator as any).valueToCode(
                            block,
                            'DURATION',
                            (javascriptGenerator as any).ORDER_ATOMIC
                          );

                          // If no duration is provided, don't pass it (to use the default)
                          if (!duration) {
                            return `this.toastService.show${toastType.charAt(0).toUpperCase() + toastType.slice(1)}(${message});\n`;
                          } else {
                            return `this.toastService.show${toastType.charAt(0).toUpperCase() + toastType.slice(1)}(${message}, ${duration});\n`;
                          }
                        };
                      } ,
                      // ---------------------------------------------------------------------------
                      // System AUTH blocks — the only backend-reaching blocks allowed on the
                      // sandboxed landingPage (Track C / public-landing-and-signup.md).
                      // login → authService; signup join/found → the isolated signup CF.
                      // ---------------------------------------------------------------------------
                      customBlockForAuthLogin() {
                        Blockly.Blocks['auth_login'] = {
                          init: function () {
                            this.appendDummyInput().appendField('login');
                            this.appendValueInput('EMAIL').setCheck('String').appendField('email');
                            this.appendValueInput('PASSWORD').setCheck('String').appendField('password');
                            this.setInputsInline(false);
                            // VALUE block: returns a string result — 'success', or an end-user-worthy
                            // error message. Plug into `set string variable [loginStatus] to …`, then
                            // show loginStatus in your UI. (No toast — login errors are the end user's,
                            // so the builder controls how they appear.)
                            this.setOutput(true, 'String');
                            this.setColour('#2e7d32');
                            this.setTooltip("Sign in (scoped to this project's auth pool). Returns 'success' or an end-user error message — store it in a string variable and show it.");
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['auth_login'] = function (block: any) {
                          const email = (javascriptGenerator as any).valueToCode(block, 'EMAIL', (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          const password = (javascriptGenerator as any).valueToCode(block, 'PASSWORD', (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          return [`await this.authService.landingLogin(${email}, ${password})`, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
                      // Landing-only VALUE block: email a Password reset link (glossary). Returns 'success' or a message
                      // for the person, like login and sign up — it says plainly when no account uses the email
                      // (owner, 2026-09-26).
                      customBlockForAuthSendPasswordReset() {
                        Blockly.Blocks['auth_send_password_reset'] = {
                          init: function () {
                            this.appendDummyInput().appendField('send password reset link');
                            this.appendValueInput('EMAIL').setCheck('String').appendField('email');
                            this.setInputsInline(false);
                            this.setOutput(true, 'String');
                            this.setColour('#2e7d32');
                            this.setTooltip("Email a password reset link to this address. Returns 'success', or a message for the person — e.g. 'No account found with this email.' — store it in a string variable and show it.");
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['auth_send_password_reset'] = function (block: any) {
                          const email = (javascriptGenerator as any).valueToCode(block, 'EMAIL', (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          return [`await this.authService.landingSendPasswordReset(${email})`, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
                      // (auth_signup_join removed — public signup only founds a workspace; a tenant
                      //  admin adds users in-app via `add user to my tenant`, not via public signup.)
                      // ---------------------------------------------------------------------------
                      // Tenant-admin blocks — AUTHENTICATED pages only (full toolbox, never the
                      // sandbox). The landing page founds the tenant (founder = admin); growing it
                      // happens in-app: a tenant-admin adds users / assigns roles. The provisionUser
                      // CF authorizes (same tenant + caller's role is 'admin') and enforces the last-admin rule.
                      // Empty role → backend assigns the 'inactive' sentinel (no access until set).
                      // ---------------------------------------------------------------------------
                      customBlockForTenantAddUser() {
                        Blockly.Blocks['tenant_add_user'] = {
                          init: function () {
                            this.appendDummyInput().appendField('invite user to my tenant');
                            this.appendValueInput('EMAIL').setCheck('String').appendField('email');
                            this.appendValueInput('USERNAME').setCheck('String').appendField('name');
                            this.appendValueInput('ROLE').setCheck('String').appendField('role');
                            this.setInputsInline(false);
                            // VALUE block — returns 'success' or an end-user message. Store it in a string variable + show it.
                            this.setOutput(true, 'String');
                            this.setColour('#2e7d32');
                            // Invite flow (tenant-invite-flow): this creates a PENDING invite + emails a tokenized
                            // accept link. No identity/password is created now — the person sets their own password
                            // on the accept page. role is OPTIONAL: empty → they land inactive (activate later with
                            // 'edit user'); a non-empty role must exist and can never be 'admin'.
                            this.setTooltip("Tenant-admin only: invite a NEW user to YOUR tenant. Emails them a link to set a password and join. Returns 'success' or an error. Leave role empty → they start inactive; a role must exist and can't be 'admin'.");
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['tenant_add_user'] = function (block: any) {
                          const v = (n: string) => (javascriptGenerator as any).valueToCode(block, n, (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          return [`await this.userService.inviteToTenant(${v('EMAIL')}, ${v('USERNAME')}, ${v('ROLE')})`, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
                      customBlockForTenantCancelInvite() {
                        Blockly.Blocks['tenant_cancel_invite'] = {
                          init: function () {
                            this.appendDummyInput().appendField('cancel invite');
                            this.appendValueInput('EMAIL').setCheck('String').appendField('email');
                            this.setInputsInline(false);
                            // VALUE block — returns 'success' or an end-user error message.
                            this.setOutput(true, 'String');
                            this.setColour('#b45309');
                            this.setTooltip("Tenant-admin only: cancel a PENDING invite in YOUR tenant, found by email. The accept link stops working. Returns 'success' or an error.");
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['tenant_cancel_invite'] = function (block: any) {
                          const v = (n: string) => (javascriptGenerator as any).valueToCode(block, n, (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          return [`await this.userService.cancelInvite(${v('EMAIL')})`, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
                      customBlockForTenantEditUserRole() {
                        Blockly.Blocks['tenant_edit_user_role'] = {
                          init: function () {
                            this.appendDummyInput().appendField('edit user');
                            this.appendValueInput('EMAIL').setCheck('String').appendField('person');
                            this.appendValueInput('USERNAME').setCheck('String').appendField('display name');
                            this.appendValueInput('ROLE').setCheck('String').appendField('role');
                            this.setInputsInline(false);
                            // VALUE block — returns 'success' or an end-user error message.
                            this.setOutput(true, 'String');
                            this.setColour('#2e7d32');
                            this.setTooltip("Tenant-admin only: change a person in your workspace — their role and/or display name. The person is their record, username or email. Leave display name or role EMPTY to keep it unchanged. A role must be an existing role, 'admin', or 'inactive' (no access) — otherwise it's rejected with an error toast. The last admin can never be demoted.");
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['tenant_edit_user_role'] = function (block: any) {
                          const v = (n: string) => (javascriptGenerator as any).valueToCode(block, n, (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          return [`await this.userService.editUser(${v('EMAIL')}, ${v('USERNAME')}, ${v('ROLE')})`, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
                      customBlockForUserCreateAccount() {
                        Blockly.Blocks['user_create_account'] = {
                          init: function () {
                            this.appendDummyInput().appendField('add user');
                            this.appendDummyInput().appendField('⚠ admin role only — other roles fail');
                            this.appendDummyInput()
                              .appendField('by')
                              .appendField(new Blockly.FieldDropdown([['email', 'email'], ['username', 'username']]), 'MODE');
                            this.appendValueInput('VALUE').setCheck('String').appendField('value');
                            this.appendValueInput('PASSWORD').setCheck('String').appendField('password (username only)');
                            this.appendValueInput('ROLE').setCheck('String').appendField('role');
                            this.setInputsInline(false);
                            this.setOutput(true, 'String');
                            this.setColour('#2e7d32');
                            this.setTooltip("Admin only. Choose 'email' → sends an invitation link (they set their own password; the password field is ignored). Choose 'username' → creates the account now with the password you set. Email and username are each set once. Returns 'success' or an error.");
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['user_create_account'] = function (block: any) {
                          const v = (n: string) => (javascriptGenerator as any).valueToCode(block, n, (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          const mode = block.getFieldValue('MODE') || 'email';
                          return [`await this.userService.addUser('${mode}', ${v('VALUE')}, ${v('PASSWORD')}, ${v('ROLE')})`, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
                      customBlockForUserSetEmail() {
                        Blockly.Blocks['user_set_email'] = {
                          init: function () {
                            this.appendDummyInput().appendField('add email');
                            this.appendDummyInput().appendField('⚠ admin role only — set once');
                            this.appendValueInput('IDENTIFIER').setCheck('String').appendField('person');
                            this.appendValueInput('EMAIL').setCheck('String').appendField('email');
                            this.setInputsInline(false);
                            this.setOutput(true, 'String');
                            this.setColour('#2e7d32');
                            this.setTooltip("Admin only. Sends a confirmation link to add an email to an existing person — their record, username or email. Once they confirm, they can sign in with username or email — and the email can't be changed. Returns 'success' or an error.");
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['user_set_email'] = function (block: any) {
                          const v = (n: string) => (javascriptGenerator as any).valueToCode(block, n, (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          return [`await this.userService.addEmail(${v('IDENTIFIER')}, ${v('EMAIL')})`, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
                      customBlockForUserSetUsername() {
                        Blockly.Blocks['user_set_username'] = {
                          init: function () {
                            this.appendDummyInput().appendField('add username');
                            this.appendDummyInput().appendField('⚠ admin role only — a username can\'t be changed once set');
                            this.appendValueInput('IDENTIFIER').setCheck('String').appendField('person');
                            this.appendValueInput('USERNAME').setCheck('String').appendField('username');
                            this.setInputsInline(false);
                            this.setOutput(true, 'String');
                            this.setColour('#2e7d32');
                            this.setTooltip("Admin only. Sets a username (letters/numbers only, unique in this app) on an existing person, found by their record, username or email. A username can't be changed once set. Returns 'success' or an error.");
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['user_set_username'] = function (block: any) {
                          const v = (n: string) => (javascriptGenerator as any).valueToCode(block, n, (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          return [`await this.userService.setUserUsername(${v('IDENTIFIER')}, ${v('USERNAME')})`, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
                      customBlockForUserResetPassword() {
                        Blockly.Blocks['user_reset_password'] = {
                          init: function () {
                            this.appendDummyInput().appendField("reset user password");
                            this.appendDummyInput().appendField('⚠ admin role only — other roles fail');
                            this.appendValueInput('IDENTIFIER').setCheck('String').appendField('person');
                            this.appendValueInput('NEW_PASSWORD').setCheck('String').appendField('new password');
                            this.setInputsInline(false);
                            this.setOutput(true, 'String');
                            this.setColour('#b45309');
                            this.setTooltip("Only a signed-in user whose role is 'admin' (or the app builder) can run this — other roles get a 'Not authorized' error. Sets a new one-time password for a person in your workspace, found by their record, username or email. Returns 'success' or an error.");
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['user_reset_password'] = function (block: any) {
                          const v = (n: string) => (javascriptGenerator as any).valueToCode(block, n, (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          return [`await this.userService.resetUserPassword(${v('IDENTIFIER')}, ${v('NEW_PASSWORD')})`, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
                      customBlockForUserChangePassword() {
                        Blockly.Blocks['user_change_password'] = {
                          init: function () {
                            this.appendDummyInput().appendField('change my password');
                            this.appendValueInput('CURRENT').setCheck('String').appendField('current password');
                            this.appendValueInput('NEW').setCheck('String').appendField('new password');
                            this.setInputsInline(false);
                            this.setOutput(true, 'String');
                            this.setColour('#2e7d32');
                            this.setTooltip("The signed-in user changes their OWN password (needs their current password). Returns 'success' or an error.");
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['user_change_password'] = function (block: any) {
                          const v = (n: string) => (javascriptGenerator as any).valueToCode(block, n, (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          return [`await this.authService.changeMyPassword(${v('CURRENT')}, ${v('NEW')})`, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
                      customBlockForAuthSignupFound() {
                        Blockly.Blocks['auth_signup_found'] = {
                          init: function () {
                            this.appendDummyInput().appendField('sign up');
                            this.appendValueInput('EMAIL').setCheck('String').appendField('email');
                            this.appendValueInput('PASSWORD').setCheck('String').appendField('password');
                            this.appendValueInput('USERNAME').setCheck('String').appendField('name');
                            this.appendValueInput('TENANTNAME').setCheck('String').appendField('workspace name');
                            this.setInputsInline(false);
                            // VALUE block (mirrors `login`): returns 'success', or an end-user error
                            // message (invalid email / "Please enter your name" / "Workspace name is
                            // required" / "An account with this email already exists. Please sign in.").
                            // Plug into `set string variable [signupStatus] to …` and show it.
                            this.setOutput(true, 'String');
                            this.setColour('#2e7d32');
                            this.setTooltip("Sign up: create the user + their workspace and log them in. Returns 'success' or an end-user error message — store it in a string variable and show it.");
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['auth_signup_found'] = function (block: any) {
                          const v = (n: string) => (javascriptGenerator as any).valueToCode(block, n, (javascriptGenerator as any).ORDER_ATOMIC) || "''";
                          return [`await this.authService.signupPublic('foundTenant', { email: ${v('EMAIL')}, password: ${v('PASSWORD')}, userName: ${v('USERNAME')}, tenantName: ${v('TENANTNAME')} })`, (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
                      // Landing-only VALUE block: the published app version (window.ZAVO_RUNTIME.version).
                      customBlockForAppVersion() {
                        Blockly.Blocks['app_version'] = {
                          init: function () {
                            this.appendDummyInput().appendField('app version');
                            this.setOutput(true, 'String');
                            this.setColour('#2e7d32');
                            this.setTooltip('The published version of this app (e.g. "1.2.0"). Empty in preview / unpublished. Plug into a string variable to show it.');
                            this.setHelpUrl('');
                          },
                        };
                        (javascriptGenerator as any).forBlock['app_version'] = function () {
                          return ['this.authService.getRuntimeVersion()', (javascriptGenerator as any).ORDER_ATOMIC];
                        };
                      } ,
};